


























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AssociadoModel } from "@/models/cadastros/assistencia/AssociadoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { AssociadoResultadoFiltroModel } from "@/models/cadastros/assistencia/AssociadoResultadoFiltroModel";
import { PaginationModel } from "@/models/commons/PaginationModel";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import axios, { AxiosResponse } from "axios";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaAssociados extends Vue {
  cabecalhoAssociados = [
    { text: "CPF / CNPJ", value: "cpfCnpj", width: "30%" },
    { text: "Nome / Razão Social", value: "nomeRazaoSocial", width: "50%" },
    { text: 'Frota', value: 'frota', width: "15%", sortable: false },
    { text: 'Ativo', value: 'ativo', width: "15%", sortable: false },
    { text: "Ação", value: "actions", width: "15%", sortable: false }
  ];

  dialogType = "";
  showDialog = false;
  showDialogAtivarInativar = false;
  showDialogClienteAtivarInativar = false;
  dialogTitle = "";
  dialogMessage = "";

  associadoFrota = {
    id: 0,
    frota: true
  };

  clienteStatus = {
    id: 0,
    ativo: true
  };

  beforeRouteEnter(to: any, from: any, next: any) {
    this.nomeFiltro = "";
    next();
  }

  nomeFiltro = "";
  cpfCnpjFiltro = "";
  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  estado: EstadosCidades = {cidades: [], sigla: "", nome: ""};
  cidade: string = "";

  resultadoFiltroModel: AssociadoResultadoFiltroModel = {
    content: []
  };
  loading = false;
  totalAssociados = 0;
  options: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 0
  };

  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));
  }

  @Watch("estado")
  selectCities() {
    this.cidades = [];
    this.cidade = "";
    if (this.estado) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.estado?.sigla
      )[0].cidades;
    } else {
       this.estado = {cidades: [], sigla: "", nome: ""};
    }
  }

  @Watch("options.page")
  handlePagination() {
    if (this.filtroPreenchido()) {
      this.getData();
    }
  }

  @Watch("options.itemsPerPage")
  handleItemsPerPage() {
    if (this.filtroPreenchido()) {
      if (this.options.page == 1) {
        this.getData();
      } else {
        this.options.page = 1;
      }
    }
  }

  created() {
    this.nomeFiltro = "";
  }

  ativarCpfCnpjFrota(cpfCnpj: string) {
    if (cpfCnpj.length <= 11) {
      return true
    }
    return false;
  }

  detalhes(associadoModel:AssociadoModel) {
    const id = associadoModel.id!.toString();
    this.$router.push({ name: 'DetalhesCliente', params: { idCliente: id } });
  }


  habilitarDesabilitarFrota(associado: AssociadoModel) {
    this.associadoFrota = {
      id: associado.id ?? 0,
      frota: associado.frota ?? true
    };

    if (!this.associadoFrota.frota){
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar inativação",
        `Deseja inativar FROTA para o associado ${associado.nomeRazaoSocial} ?`
      );
    } else {
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar ativação",
        `Deseja ativar FROTA para o associado ${associado.nomeRazaoSocial} ?`
      );
    }
  }

  habilitarDesabilitarCliente(associado: AssociadoModel) {
    this.clienteStatus = {
      id: associado.id ?? 0,
      ativo: associado.ativo ?? true
    };

    if (!this.clienteStatus.ativo){
      this.openDialogClienteAtivarInativar(
        "confirm",
        "Confirmar inativação",
        `Deseja inativar o cliente ${associado.nomeRazaoSocial} ?`
      );
    } else {
      this.openDialogClienteAtivarInativar(
        "confirm",
        "Confirmar ativação",
        `Deseja ativar o cliente ${associado.nomeRazaoSocial} ?`
      );
    }
  }

  ativarInativarFrota() {
    if (this.associadoFrota.frota == false) {
      ServicosAssistenciaService.inativarFrota(this.associadoFrota.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Associado inativado FROTA com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao inativar FROTA para o associado."
          );
          console.error(err);
        }
      );
    } else {
      ServicosAssistenciaService.ativarFrota(this.associadoFrota.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Associado ativado FROTA com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao ativar FROTA para o associado."
          );
          console.error(err);
        }
      )
    }
  }

  ativarInativarCliente() {
    if (this.clienteStatus.ativo == false) {
      ServicosAssistenciaService.inativarCliente(this.clienteStatus.id).then(
        res => {
          this.closeDialog();
          this.openDialogClienteAtivarInativar(
            "success",
            "Sucesso",
            "Cliente inativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogClienteAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao inativar o cliente."
          );
          console.error(err);
        }
      );
    } else {
      ServicosAssistenciaService.ativarCliente(this.clienteStatus.id).then(
        res => {
          this.closeDialog();
          this.openDialogClienteAtivarInativar(
            "success",
            "Sucesso",
            "Cliente ativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogClienteAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao ativar o cliente."
          );
          console.error(err);
        }
      )
    }
  }

  closeDialogAtivarInativar(){
    if (this.resultadoFiltroModel.content){
      const index = this.resultadoFiltroModel.content?.findIndex(item => {
        return item.id == this.associadoFrota.id;
      });

      this.resultadoFiltroModel.content[index].frota = !this.associadoFrota.frota;
      this.closeDialog();
    }
  }

  closeDialogClienteAtivarInativar(){
    if (this.resultadoFiltroModel.content){
      const index = this.resultadoFiltroModel.content?.findIndex(item => {
        return item.id == this.clienteStatus.id;
      });

      this.resultadoFiltroModel.content[index].ativo = !this.clienteStatus.ativo;
      this.closeDialog();
    }
  }

  filtrar(paging?: boolean) {
    if (!this.filtroPreenchido()) {
      this.openDialog(
        "error",
        "Informe o filtro",
        "Informe pelo menos um campo no filtro."
      );
    } else {
      if (!paging) {
        this.options.page = 1;
        this.getData();
      }
    }
  }

  getData() {
    this.loading = true;
    ServicosAssistenciaService.pesquisarAssociadosAssistencia(
      this.cpfCnpjFiltro.replace(/\D/g, ""),
      this.nomeFiltro,
      this.options?.page ? this.options?.page - 1 : 0,
      this.options.itemsPerPage,
      this.options?.sortBy ? this.options?.sortBy[0] : "",
      this.options?.sortDesc && this.options?.sortDesc[0] ? "DESC" : "ASC",
      this.estado.sigla ? this.estado.sigla : "",
      this.cidade ? this.cidade : ""
    ).then(
      (res) => {
        this.resultadoFiltroModel.content = res.content.map((c: any) => {
          return {
            id: c.id,
            cpfCnpj: c.cpfCnpj,
            nomeRazaoSocial: c.nome,
            frota: c.frota,
            ativo: c.ativo            
          } as AssociadoModel;
        });
        this.options.itemsLength = res.totalElements;
        this.totalAssociados = res.pageable.totalElements;
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  private filtroPreenchido(): boolean {
    return (!!this.cpfCnpjFiltro && !!this.cpfCnpjFiltro.trim()) ||
      (!!this.nomeFiltro && !!this.nomeFiltro.trim()) ||
      (!!this.estado && !!this.estado.sigla);
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  private openDialogAtivarInativar(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogAtivarInativar = true;
  }

  private openDialogClienteAtivarInativar(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogClienteAtivarInativar = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    this.showDialogAtivarInativar = false;
    this.showDialogClienteAtivarInativar = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
